import {inject, Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {API_URL_PLACEHOLDER} from '../constants/api-url-placeholder.constant';
import {ServerSelectionService} from '../services/server-selection/server-selection.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    private readonly serverSelectionService = inject(ServerSelectionService);

    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (request.url.indexOf(API_URL_PLACEHOLDER) === 0) {
            request = request.clone({
                url: request.url.replace(API_URL_PLACEHOLDER, this.serverSelectionService.getSelectedServerUrl())
            });
        }
        return next.handle(request);
    }
}
